import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import { formatDate } from "date-fns";
import ReactGA from 'react-ga4';
import { useNavigate } from "react-router";
import { SCREEN_NAMES } from "src/constants/screenNames";

interface LinkMenuItemProps {
  path: string;
  selectedDate: Date | null;
  primaryText: string;
  secondaryText: string;
  icon: React.ReactNode;
};

export const LinkMenuItem = ({
  path,
  selectedDate,
  primaryText,
  secondaryText,
  icon,
}: LinkMenuItemProps) => {
  const navigate = useNavigate();

  const handleDateMenuItemClick = (path: string) => {
    const date = formatDate(selectedDate || new Date(), 'yyyy-MM-dd');
    ReactGA.event('click', { screen_name: SCREEN_NAMES.DASHBOARD, button_name: 'date', label: date });

    console.log(`Navigate to: /${path}/${date}/${date}`);
    void navigate(`/${path}/${date}/${date}`);
  };

  return (
    <MenuItem onClick={() => handleDateMenuItemClick(path)}>
      <ListItemIcon>
        {icon}
      </ListItemIcon>
      <ListItemText
        primary={primaryText}
        secondary={secondaryText}
      />
    </MenuItem>
  );
};
